import { Link } from 'react-router-dom';
import { useBlogPosts } from '../../hooks/useBlogPosts';
import { Helmet } from 'react-helmet';
import { LoadingSpinner } from '../../components/LoadingSpinner';

export function Blog() {
  const { posts, isLoading, error } = useBlogPosts();

  if (isLoading) return <LoadingSpinner />;
  if (error) return <div className="text-center py-16">Error loading blog posts</div>;

  return (
    <>
      <Helmet>
        <title>Blog - Furgos Río</title>
        <meta 
          name="description" 
          content="Descubre consejos, rutas y experiencias para sacar el máximo partido a tu aventura en camper por Galicia" 
        />
      </Helmet>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Blog de Furgos Río
          </h1>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Descubre consejos, rutas y experiencias para sacar el máximo partido a tu aventura en camper
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {posts.map((post) => (
            <article 
              key={post.slug} 
              className="bg-white rounded-2xl shadow-sm overflow-hidden hover:shadow-lg transition-shadow duration-300"
            >
              <Link to={`/blog/${post.slug}`} className="block">
                <img
                  src={post.coverImage}
                  alt={post.title}
                  className="w-full h-48 object-cover"
                  loading="lazy"
                />
                <div className="p-6">
                  <time dateTime={post.date} className="text-sm text-gray-500">
                    {new Date(post.date).toLocaleDateString('es-ES', {
                      year: 'numeric',
                      month: 'long',
                      day: 'numeric'
                    })}
                  </time>
                  <h2 className="mt-2 text-xl font-semibold text-gray-900">
                    {post.title}
                  </h2>
                  <p className="mt-3 text-gray-600 line-clamp-3">
                    {post.excerpt}
                  </p>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {post.tags.map((tag) => (
                      <span
                        key={tag}
                        className="inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium bg-brand/10 text-brand"
                      >
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </>
  );
} 